export * from './vermerk-delete-request.interface';
export * from './vermerk-delete-response.interface';
export * from './vermerk-delete.shapes';
